import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import React from 'react';
import { modules } from './constants';

// We can't match exactly the tooltips to the module keys because some of the tooltips
// appear on hover of non-module elements,
// like SECONDARY_ANALYSIS_PROJECT_DETAIL and TERTIARY_PROJECT_DETAIL
var sidebarTooltipTexts = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, modules.SECONDARY_ANALYSIS, __jsx(React.Fragment, null, "Process FASTQ files from Parse Biosciences Evercode WT kits to generate pipeline output files including reports, metrics and count matrices.", __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/36214328983828-Guided-walkthrough-Pipeline-module-set-up",
  target: "_blank",
  rel: "noreferrer"
}, "Guided Walkthrough: Pipeline module set-up"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide#h_01HZ4VDNQ8SPEWG1JFT5GHTXKC",
  target: "_blank",
  rel: "noreferrer"
}, "User Guide - Pipeline module"))), modules.SECONDARY_ANALYSIS_OUTPUT, __jsx(React.Fragment, null, "View Pipeline Run reports and download Pipeline output files", __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/36215329630228-Guided-walkthrough-Pipeline-Outputs",
  target: "_blank",
  rel: "noreferrer"
}, "Guided Walkthrough: Pipeline Outputs"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide#h_01HZ4VDNQ8QEZSTRDHST7BK3DZ",
  target: "_blank",
  rel: "noreferrer"
}, "User Guide - Pipeline Outputs"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/31579430276372-How-to-troubleshoot-Pipeline-failures-in-Trailmaker",
  target: "_blank",
  rel: "noreferrer"
}, "How to troubleshoot Pipeline failures in Trailmaker"), ' ', "(requires support suite login)")), modules.DATA_MANAGEMENT, __jsx(React.Fragment, null, "Processed data files are input for downstream filtering, integration and cell type annotation, as well as deep dive visualization and exploration of gene expression and differential expression. A range of fully customizable plots enable the generation of publication-ready figures.", __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/36215511478292-Guided-walkthrough-Insights-module-set-up",
  target: "_blank",
  rel: "noreferrer"
}, "Guided Walkthrough: Insights module set-up"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide#h_01HZ4VDNQ80HNKPV6CDAW8ZX16",
  target: "_blank",
  rel: "noreferrer"
}, "User Guide - Insights module"), __jsx("br", null), __jsx("br", null))), modules.DATA_PROCESSING, __jsx(React.Fragment, null, "View quality control plots and adjust settings for filtering, integration and clustering.", __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/36215974172692-Guided-walkthrough-Insights-Data-Processing",
  target: "_blank",
  rel: "noreferrer"
}, "Guided Walkthrough: Insights Data Processing"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide#h_01HZ4VDNQ9D1X142H65V6GHQ22",
  target: "_blank",
  rel: "noreferrer"
}, "User Guide - Data Processing section"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/31741233000468-How-to-adjust-data-processing-settings-to-fit-your-dataset-and-troubleshoot-data-processing-failures",
  target: "_blank",
  rel: "noreferrer"
}, "How to adjust data processing settings to fit your dataset and troubleshoot data processing failures"))), modules.DATA_EXPLORATION, __jsx(React.Fragment, null, "Take a deep dive into your dataset: view marker heatmap and gene expression, customize and annotate clusters, and perform differential expression and pathway analysis.", __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/36216095150484-Guided-walkthrough-Insights-Data-Exploration",
  target: "_blank",
  rel: "noreferrer"
}, "Guided Walkthrough: Insights Data Exploration"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide#h_01HZ4VDNQAYF2CF8PEDVNAXA7B",
  target: "_blank",
  rel: "noreferrer"
}, "User Guide - Data Exploration section"))), modules.PLOTS_AND_TABLES, __jsx(React.Fragment, null, "A range of plot types are available to visualize your data, all of which can be customized to your design preferences and exported as high resolution images.", __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/36216493945364-Guided-walkthrough-Insights-Plots-and-Tables",
  target: "_blank",
  rel: "noreferrer"
}, "Guided Walkthrough: Insights Plots and Tables"), __jsx("br", null), __jsx("br", null), __jsx("a", {
  href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide#h_01HZ4VDNQBKY9VX7NF5XX1RTWT",
  target: "_blank",
  rel: "noreferrer"
}, "User Guide - Plots and Tables section")));
var SidebarTitle = function SidebarTitle(props) {
  var type = props.type,
    children = props.children;
  return __jsx(_Tooltip, {
    title: __jsx("div", {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onKeyDown: function onKeyDown(e) {
        return e.key === 'Enter' && e.stopPropagation();
      }
    }, sidebarTooltipTexts[type]),
    mouseEnterDelay: 0.5,
    placement: "right"
  }, children);
};
export default SidebarTitle;